import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import PhoneIcon from '../../assets/icons/PhoneIcon'
import InstagramIcon from '../../assets/icons/InstagramIcon'
import YoutubeIcon from '../../assets/icons/YoutubeIcon'
import WhatsappIcon from '../../assets/icons/WhatsappIcon'
import PageTitle from '../../components/common/PageTitle'
import ServicesCard from '../../components/cards/ServicesCard'
import LeftImage from '../../components/common/LeftImage'
import SectionHeader from '../../components/common/SectionHeader'
import { useDispatch, useSelector } from 'react-redux'
import { getOtherServices, getSingleData } from '../../services/actions/MainAction'

function SingleService() {
  const contentData = useSelector(state => state.Data.contentData);
  const otherServices = useSelector(state => state.Data.otherServices);
  const lang_id = useSelector(state => state.Data.lang_id);
  const [singleData, setSingleData] = useState("");
  const params = useParams();
  const dispatch = useDispatch();
  useEffect(()=>{
    window.scrollTo(0,0)
    dispatch(getSingleData(`services/${params?.id}?lang_id=${lang_id}`))
    .then(resp=>{
      setSingleData(resp);
      if(resp){
        dispatch(getOtherServices(lang_id,resp?.id))
      }
    })
  },[params?.id, lang_id])




  
  return (
    <main className=' pt-[0px] min-h-[160vh] mb-[50px]'>
      <PageTitle title={singleData?.translate?.title} />
      <div className='container'>
        <div className='grid items-start grid-cols-2 gap-[50px] mt-[30px] max-[720px]:grid-cols-1 gap-[30px]'>
         
        <LeftImage url={singleData?.image_full_url} />
          <div>
            <div className='list-permission innerTextStyle' dangerouslySetInnerHTML={{__html:singleData?.translate?.description}}></div>
          </div>
        </div>
      </div>
     <section className="mt-[50px]">
       <div  className='container2'>
        <SectionHeader title={contentData?.other_service} />
        <div  className='grid grid-cols-4 gap-[40px]  relative mt-[30px] max-[1200px]:grid-cols-3 gap-y-[20px] max-[800px]:grid-cols-2 max-[500px]:grid-cols-1 gap-y-[0px]'>
          {
            otherServices?.map((data, i) => {
              return (
                <ServicesCard key={i} data={data}/>
              )
            })
          }
        </div>
      </div>
     </section>
    </main>
  )
}

export default SingleService

 
